/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import { DeviceModel } from '../../core/device/DeviceModel';
import { appRunning } from '../appl/appl.reducers';
import { VuLogger } from '../../core/logging';
import {
    onMouseOverOverlayDialogOperations,
    onMouseOutOverlayDialogOperations,
    hideOverlayDialog,
} from '../overlaydialog/overlaydialog.reducers';

// GLOBAL_MOUSE_TRAP value to be the same as of file src/store/error/erroroverlays.reducers.ts
const GLOBAL_MOUSE_TRAP: string = 'HideErrorScreenOverlays';

/**
 * Below reducers are related to operations on key events.
 */
export const onKeyOkErrorScreen = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.LANGUAGE_NOT_SUPPORTED_OVERLAY:
            dispatch(onKeyOkLanguageNotSupportedOverlay());
            break;

        case ScreenTaskControllerTypes.SOS_ERROR_TASKS:
            dispatch(onKeyOkSos());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY:
            onKeyOkTemporaryServiceConnectionIssueOverlay();
            break;

        default:
            break;
    }
};

export const onKeyOkLanguageNotSupportedOverlay = () => (dispatch: Function) => {
    dispatch(appRunning());
    dispatch(hideOverlayDialog());
    VuLogger.logLanguageNotSupportedOverlayUserActionEvent();
};

export const onKeyOkSos = () => () => {
    VuLogger.logAppExitEvent(VuLogger.AppExitActions.EXIT);
    DeviceModel.closeApplication();
};

export const onKeyOkTemporaryServiceConnectionIssueOverlay = () => {
    VuLogger.logAppExitEvent(VuLogger.AppExitActions.EXIT);
    DeviceModel.closeApplication();
};

export const onMouseClickError = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.LANGUAGE_NOT_SUPPORTED_OVERLAY:
            dispatch(onMouseClickLanguageNotSupportedOverlay());
            break;

        case ScreenTaskControllerTypes.SOS_ERROR_TASKS:
            dispatch(onMouseClickSos());
            break;
        case ScreenTaskControllerTypes.TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY:
            dispatch(onMouseClickTemporaryServiceConnectionIssueOverlay());
            break;

        default:
            break;
    }
};

export const onMouseClickLanguageNotSupportedOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        if (value !== GLOBAL_MOUSE_TRAP) {
            dispatch(onKeyOkLanguageNotSupportedOverlay());
        }
    };

export const onMouseClickSos = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;
    if (value !== GLOBAL_MOUSE_TRAP) {
        dispatch(onKeyOkSos());
    }
};

export const onMouseClickTemporaryServiceConnectionIssueOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        if (value !== GLOBAL_MOUSE_TRAP) {
            dispatch(onKeyOkTemporaryServiceConnectionIssueOverlay());
        }
    };

export const onMouseOverError = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.LANGUAGE_NOT_SUPPORTED_OVERLAY:
        case ScreenTaskControllerTypes.SOS_ERROR_TASKS:
        case ScreenTaskControllerTypes.TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY:
            dispatch(onMouseOverOverlayDialogOperations());
            break;

        default:
            break;
    }
};

export const onMouseOutErrorScreen = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.LANGUAGE_NOT_SUPPORTED_OVERLAY:
        case ScreenTaskControllerTypes.SOS_ERROR_TASKS:
        case ScreenTaskControllerTypes.TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY:
            dispatch(onMouseOutOverlayDialogOperations());
            break;

        default:
            break;
    }
};
